/* eslint-disable */

import React from 'react';
import pdfImg from 'src/images/icons/pdf-file.png';

const PdfIcon = ({ style, ...otherProps }) => (
  <img
    src={pdfImg}
    alt="PDF"
    style={{
      width: 21,
      height: 28,
      ...style,
    }}
    {...otherProps}
  />
);

export default PdfIcon;
